import { render, staticRenderFns } from "./zupload.vue?vue&type=template&id=60ca81e8&scoped=true"
import script from "./zupload.vue?vue&type=script&lang=js"
export * from "./zupload.vue?vue&type=script&lang=js"
import style0 from "./zupload.vue?vue&type=style&index=0&id=60ca81e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca81e8",
  null
  
)

export default component.exports